import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'
import { shuffle } from '~/utils'

const VARIABLES = ['a', 'b', 'c', 'x', 'y', 'z']
const RANGE_DATA: RangeDataModel = {
  1: {
    totalTerms: 2,
    minValue: 1,
    maxValue: 10,
    maxHistoryLength: 7,
  },
  2: {
    totalTerms: 3,
    minValue: 1,
    maxValue: 10,
    maxHistoryLength: 7,
  },
  3: {
    totalTerms: 3,
    minValue: -10,
    maxValue: 10,
    maxHistoryLength: 10,
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  totalTerms: number
  minValue: number
  maxValue: number
  maxHistoryLength: number
}

export interface EquationPartsModel {
  integer: number
  variable?: string
}

export enum TermsType {
  SIGN,
  INTEGER,
  COEFFICIENT,
  VARIABLE,
}

export interface ActivityDataModel {
  equationString: string
  equationParts: EquationPartsModel[]
  variableMap: Map<string, string>
  maxHistoryLength: number
}

/**
 * generates a algebraic equation
 * @param difficultyLevel difficulty level of the activity
 * @param taskHistory equations to excludes
 * @returns generated equation in parts and equation string
 */
export function generateInsertValueActivityData(difficultyLevel: number, taskHistory: string[]): ActivityDataModel {
  const range = RANGE_DATA[difficultyLevel]
  const totalAlgebraicTerms = getRandomInt(1, range.totalTerms)
  const variableIndexes: number[] = []
  const variables: string[] = []
  const variableValues: number[] = []
  let equationParts: EquationPartsModel[] = []
  // eslint-disable-next-line
  for (let i = 0; i < totalAlgebraicTerms; i++) {
    variableIndexes[i] = getRandomInt(0, VARIABLES.length - 1, variableIndexes)
    variables[i] = VARIABLES[variableIndexes[i]]
    variableValues[i] = getRandomInt(1, range.maxValue, [0, ...variableValues])
    equationParts[i] = {
      integer: getRandomInt(range.minValue, range.maxValue, [0]),
      variable: VARIABLES[variableIndexes[i]],
    }
  }
  // eslint-disable-next-line
  for (let i = totalAlgebraicTerms; i < range.totalTerms; i++) {
    equationParts[i] = {
      integer: getRandomInt(range.minValue, range.maxValue, [0]),
    }
  }
  equationParts = shuffle(equationParts)
  let equationString = ''
  equationParts.forEach((item) => {
    equationString += `${item.integer} - ${item.variable}`
  })
  if (taskHistory.includes(equationString)) return generateInsertValueActivityData(difficultyLevel, taskHistory)
  const variableMap = new Map()
  variables.forEach((variable, index) => {
    variableMap.set(variable, variableValues[index])
  })
  return { equationString, variableMap, equationParts, maxHistoryLength: range.maxHistoryLength }
}

export function checkAnswer(
  equationParts: EquationPartsModel[],
  variableMap: Map<string, string>,
  answerMap: Map<string, string>,
): boolean {
  let isRight = true
  equationParts.forEach(({ variable }) => {
    if (variable !== undefined && answerMap.get(variable)?.toString() !== variableMap.get(variable)?.toString()) {
      isRight = false
    }
  })
  return isRight
}
